import React, { Component } from 'react';
import {
  Container,
} from './styles';
class NotFound extends Component {  
  render() {
    return (
      <Container><h1>Not Found</h1></Container>
    );
  }
}

export default NotFound;
